import React from 'react';

const SelectOption = ({ children, ...props }) => {
  return <option {...props}>{children}</option>;
};

export default SelectOption;
